import styled from '@emotion/styled'
import { Button, Stack, Typography } from '@mui/material'

export const StackContainer = styled(Stack)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '225px',
  padding: '24px',
  color: 'white'
})

export const ButtonCsvGenerate = styled(Button)(({ theme }) => ({
  borderRadius: '4px',
  color: 'black',
  marginTop: '35px',
  padding: '11px 20px 11px 24px',
  fontFamily: 'Nunito',
  fontSize: '14px',
  width: '175px',
  textTransform: 'capitalize',
  height: '32px',
  fontWeight: 700,
  backgroundColor: theme.palette.button.save.primary,
  '&:hover': {
    backgroundColor: theme.palette.button.save.hover
  },
  '&:disabled': {
    background: `${theme.palette.button.disable} !important`,
    color: theme.palette.svg.clearIcon
  }
}))

export const ButtonCsvGenerateText = styled(Typography)(({ theme }) => ({
  color: 'black',
  fontFamily: 'Nunito',
  fontSize: '14px',
  textTransform: 'capitalize',
  fontWeight: 700,
  backgroundColor: 'transparent'
}))

export const OptionContainer = styled('li')(() => ({
  display: 'flex !important',
  justifyContent: 'space-between !important',
  '&:hover': {
    backgroundColor: 'black'
  }
}))

export const OptionCounterparty = styled('span')({
  color: '#D3D3D3',
  fontSize: '14px',
  fontStyle: 'italic',
  marginLeft: '4px'
})
